import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Pen = (props) => (
  <Icon viewBox="0 0 14 14" {...props}>
    <g>
      <title>pen</title>
      <path d="M13.712 4.533L11.84 6.396l-4.28-4.26L9.43.271a.934.934 0 0 1 1.317 0l2.964 2.95a.926.926 0 0 1 0 1.311zm-7.043 7.01L0 13.923l2.389-6.64 3.854-3.836 4.28 4.26-3.854 3.836zm-3.9-2.57l-1.228 3.415 3.43-1.223L2.77 8.973z"
        fill="currentColor" fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default Pen;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Pen.js